import type { RadioGroupValueChangeDetails } from "@ark-ui/solid";
import { RadioGroup } from "@ark-ui/solid";
import { For, Show } from "solid-js";
import type { IconName } from "../icon/Icon";
import { Icon } from "../icon/Icon";

type ToggleButtonGroupProps<T> = {
  label?: string;
  value: T;
  onValueChange: (details: RadioGroupValueChangeDetails) => void;
  items: { ariaLabel: string; icon: IconName; value: T }[];
};

const ToggleButtonGroup = <T extends string>(props: ToggleButtonGroupProps<T>) => (
  <RadioGroup.Root
    value={props.value}
    class="flex items-center justify-between"
    orientation="horizontal"
    onValueChange={props.onValueChange}
  >
    <Show when={props.label}>
      <RadioGroup.Label class="min-w-0 truncate text-base-semibold text-secondary">{props.label}</RadioGroup.Label>
    </Show>
    <RadioGroup.Indicator />
    <div class="flex gap-x-0.5 rounded-sm border border-subtle bg-surface-extra-subtle">
      <For each={props.items}>
        {(item) => (
          <RadioGroup.Item
            aria-label={item.ariaLabel}
            title={item.ariaLabel}
            value={item.value}
            class="group relative flex h-7.5 items-center justify-center rounded-sm px-3 py-1.5 checked:bg-surface-default"
          >
            <div class="absolute -inset-px rounded-sm group-checked:border group-checked:border-default group-focussed:outline-default" />
            <Icon name={item.icon} size="md" type="outline" class="icon-secondary group-checked:icon-primary" />
            <RadioGroup.ItemControl />
            <RadioGroup.ItemHiddenInput />
          </RadioGroup.Item>
        )}
      </For>
    </div>
  </RadioGroup.Root>
);

export default ToggleButtonGroup;
